module.exports = {
	"de": {
		"ui.about.title.overview": "Neue Humanitäre Karten",
		"ui.about.subhead": "Herunterladen von aktuellen humanitären Karten für GIS Analyse oder für die Verwendung in GPS  Geräten und Smartphones.",
		"ui.about.overview": "Diese Plattform erlaubt die Erstellung von angepassten OpenStreetMap (OSM) Exporten für zahlreiche HOT Regionen. Sie können eine relevante Fläche und eine Liste von OSM Kartenbestandteil Tags für den Export spezifizieren. Für den Export stehen mehrere Datei Formate zur Verfügung - Esri SHP, Garmin IMG, Google KMZ, OSM PBF und SQlite SQL. Die verfügbaren OSM Daten des Export Tool werden im Minutentakt aktualisiert.",
		"ui.about.title.getting_started": "Wie man anfängt",
		"ui.about.getting_started": "",
		"ui.exports": "Exporte",
		"ui.exports.title": "Exporte",
		"ui.help": "Hilfe",
		"ui.login": "Anmelden",
		"ui.about.license": "",
		"ui.about.license.odbl": "ODbL 1.0 lizenziert",
		"ui.aoi_toolbar.tools": "",
		"ui.draw.box": "",
		"ui.draw.draw": "",
		"ui.draw.import": "",
		"ui.draw.current_view": "",
		"ui.authorized.thank_you": "",
		"configuration.description.label": "Beschreibung",
		"ui.configuration.description.label": "Beschreibung",
		"export.description.label": "Beschreibung",
		"exports.description.label": "Beschreibung",
		"configuration.description.placeholder": "",
		"configuration.feature_selection.label": "",
		"configuration.name.label": "Name",
		"ui.configuration.name.label": "Name",
		"export.name.label": "Name",
		"exports.name.label": "Name",
		"configuration.name.placeholder": "",
		"configuration.public.description": "",
		"ui.configuration.update": "",
		"ui.configuration.create": "",
		"ui.configuration.delete": "",
		"ui.configuration.title": "",
		"configuration.title": "",
		"ui.configurations": "",
		"ui.configuration.tables.label": "",
		"ui.configuration.owner.label": "Besitzer",
		"exports.owner.label": "Besitzer",
		"export.project.label": "Projekt",
		"exports.project.label": "Projekt",
		"export.area.label": "",
		"export.area": "",
		"export.created_at.label": "",
		"export.created_by.label": "",
		"export.published.label": "Veröffentlicht",
		"yes": "",
		"no": "",
		"export.export_formats.label": "",
		"export.osma.label": "",
		"ui.view_this_area": "",
		"ui.exports.status": "",
		"ui.exports.started": "",
		"ui.exports.finished": "",
		"ui.exports.duration": "",
		"ui.exports.features": "Kartenbestandteile",
		"ui.exports.rerun_export": "",
		"ui.exports.clone_export": "Kopie erstellen",
		"ui.exports.feature_selection.title": "Auswahl der Kartenbestandteile",
		"export.feature_selection.label": "Auswahl der Kartenbestandteile",
		"ui.close": "Schließen",
		"export.errors.the_geom.too_large": "",
		"export.buffer_aoi.description": "",
		"export.name.placeholder": "",
		"export.project.placeholder": "",
		"export.published.description": "",
		"export.tag_tree_search.placeholder": "",
		"nav.next": "Nächstes",
		"export.feature_selection.load_from_josm_preset": "",
		"ui.clear": "",
		"configuration.load_yaml": "",
		"ui.exports.tag_tree": "",
		"ui.exports.stored_configuration": "",
		"ui.exports.create_export": "Export erstellen",
		"ui.exports.describe_export": "Exportbeschreibung",
		"ui.exports.choose_formats": "",
		"ui.exports.select_features": "Attribute auswählen",
		"ui.exports.summary": "",
		"ui.overpass_last_updated": "",
		"ui.show_on_map": "",
		"exports.created.label": "Erstellt",
		"ui.settings": "",
		"ui.never": "",
		"exports.schedule.6hrs": "",
		"exports.schedule.daily": "",
		"exports.schedule.weekly": "",
		"exports.schedule.monthly": "",
		"ui.unknown": "",
		"ui.untitled": "",
		"runs.last_run.label": "",
		"runs.next_run.label": "",
		"runs.schedule.label": "",
		"ui.private": "Privat",
		"ui.search.only_mine": "",
		"ui.search.placeholder": "",
		"ui.search": "Suchen",
		"ui.login_to_osm": "Login bei Openstreetmap",
		"ui.hot.title": "Humanitarian OpenStreetMap Team",
		"ui.toggle_navigation": "",
		"ui.osm_export_tool.title": "OSM-Exportwerkzeug",
		"ui.create": "Erzeugen",
		"ui.hdx": "",
		"ui.about": "Über",
		"ui.log_out": "Abmelden",
		"ui.log_in": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./app/i18n/locales/de.json
// module id = 1491
// module chunks = 1